'use client';

import { WithdrawCancelIllustration } from '@/components/atoms/WithdrawCancelIllustration';

interface GameDayWithdrawProps {
	teamName: string;
}

export const GameDayWithdraw = ({ teamName }: GameDayWithdrawProps) => {
	return (
		<div className="flex w-full flex-col items-center justify-center mt-10">
			<div className="flex sm:min-w-[500px] flex-col items-center justify-center rounded-2xl border border-solid bg-orange-50 border-orange-700 p-4">
				<h1 className="text-lg sm:text-2xl font-semibold text-darkorange-600 text-wrap">{teamName} has withdrawn</h1>
			</div>

			<div className="mt-2">
				<WithdrawCancelIllustration />
			</div>
		</div>
	);
};
